/* eslint-disable class-methods-use-this */
import CollectionModule from 'client/store/modules/CollectionModule';
import ConfigurationGroupApi from 'client/api/v2/ConfigurationGroupApi';

export class ConfigurationGroupCollectionClass extends CollectionModule {
  extractModule() {
    return super.extractModule();
  }

  // --------------------------------------------------------------------------
  // Getters
  // --------------------------------------------------------------------------

  /**
   * Override method from base class to ignore applied filters when determining
   * whether the PolicyGroups collection can be refreshed.
   */
  canRefreshCollection(state = { features: { items: {} } }, getters = {}) {
    const { features } = state;
    const { boundItemsUrl, showBoundItems } = features;
    const { searchTerm } = features.items;
    const { getItemsToBind = [], getItemsToUnbind = {} } = getters;
    const hasSelectionChanged = getItemsToBind.length > 0 || getItemsToUnbind.length > 0;

    return !((boundItemsUrl && showBoundItems) || searchTerm || hasSelectionChanged);
  }
}
export default new ConfigurationGroupCollectionClass(ConfigurationGroupApi, 'id', 'name').extractModule();
